module.exports = __webpack_public_path__ + "static/media/informationIcon.cd777965.svg";